import { useState, useCallback, useMemo } from 'react';
import { CptView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Hook for managing CPT code search and filtering
 */
export function useCptSearch(cpts: CptView[]) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredCpts = useMemo(() => {
    if (!searchTerm.trim()) return cpts;

    const searchLower = searchTerm.toLowerCase().trim();
    return cpts.filter(
      (cpt) =>
        cpt.code?.toLowerCase().includes(searchLower) ||
        cpt.name?.toLowerCase().includes(searchLower) ||
        cpt.category?.toLowerCase().includes(searchLower) ||
        cpt.apcCode?.toLowerCase().includes(searchLower) ||
        cpt.grouperPointer?.toLowerCase().includes(searchLower)
    );
  }, [cpts, searchTerm]);

  const handleSearchChange = useCallback((value: string) => {
    setSearchTerm(value);
  }, []);

  const handleClearSearch = useCallback(() => {
    setSearchTerm('');
  }, []);

  return {
    searchTerm,
    filteredCpts,
    handleSearchChange,
    handleClearSearch,
  };
}
